<template>
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :offset="50"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <BgItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :title="item.title"
          :cover="item.albumPics"
          :price="item.goodsPrice"
          :industryOne="item.industryLevelOneVal"
          :industryTwo="item.industryLevelTwoVal"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Bg",
  components: { BgItem, noneList },
  data() {
    return {
      params: {
        pageNo: 0,
        pageSize: 20,
        goodsTypeId: 4,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "goodsTypeId",
                queryValue: "4",
              },
            ],
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getSearchList();
    },
    //跳转详情
    toDetail(id) {
      this.$router.push({
        path: "/detail/report",
        query: { id },
      });
    },
    // 获取行业报告搜索列表
    async getSearchList() {
      const resp = await this.$apis.searchServe.getEsTsBgList(this.params);
      console.log(resp, "resp");
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.List.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}

.list-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 15px;

  .list-item {
    margin-bottom: 12px;
    width: 170px;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
    overflow: hidden;
  }
}
</style>
